import { Box } from "@mui/system";
import { Typography } from "@mui/material";
import { muiTheme } from "@/styles/theme";

const NotFound = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        fontSize: {
          mobile: muiTheme.typography.h4_med,
          desktop: muiTheme.typography.h1_med,
        },
        color: muiTheme.colorSchemes.light.palette.main.actionBlue,
        height: "100vh",
      }}
    >
      <img
        src="/icons/not-found.svg"
        width={163}
        height={163}
        alt="Not Found"
      />
      <Typography
        component="h1"
        sx={{
          fontFamily: "Bold",
          textTransform: "uppercase",
          textAlign: "center",
          marginTop: "40px",
        }}
      >
        Error 404
      </Typography>
      <Typography
        component="h2"
        sx={{
          fontFamily: "Regular",
          textTransform: "capitalize",
          textAlign: "center",
        }}
      >
        Page Not Found
      </Typography>
    </Box>
  );
};

export default NotFound;
